import React from 'react';
import './Footer.css'; // Import the CSS for styling
import { FaFacebookF } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { FaYoutube } from "react-icons/fa";
import { NavLink } from 'react-router-dom';

const AdminFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <NavLink 
                to="/Admin/AdminPortal" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/Admin/AdminPortal/AddAdmin" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Add Admin
              </NavLink>
            </li>
            
            <li>
              <NavLink 
                to="/Admin/AdminPortal/DeleteFeatures" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Delete Features
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/Admin/AdminPortal/DeleteCar" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Edit/Delete Car
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/Admin/AdminPortal/AddWhyus" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Add Why Us Card
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/Admin/AdminPortal/Timings" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Change Timings
              </NavLink>
            </li>
            
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>
            Address:  
            <a 
              href="https://maps.app.goo.gl/7xyAb4Z1kMHLWbiA7" 
              className="link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              34 Harcourt Rd, Windsor SL4 5LZ, United Kingdom
            </a>
          </p>
          <p>
            Phone: 
            <a href="tel:01753 903449" className="link">
              01753 903449
            </a>
          </p>
        </div>

        {/* Social Media Icons */}
        <div className="footer-section">
          <h4>Call Us</h4>
          <div className="social-icons">
            
            <a 
              href="tel: 01753 903449" 
              className="call-button" 
              aria-label="Call Us"
            >
              <IoCall />
            </a>
          </div>
          <h4>Email Us</h4>
          <p>
            <a href="mailto:info@zoom-autos.co.uk" className="link">
              info@zoom-autos.co.uk
            </a>
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Zoom Autos. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default AdminFooter;
